// extracted by mini-css-extract-plugin
module.exports = {"appLogoContainer":"styles_appLogoContainer__dZVUN","appLogo":"styles_appLogo__3guso"};